export const SUPPORTED_COUNTRY_CODES = ["US", "CA", "MX"] as const;

export type SupportedCountryCode = (typeof SUPPORTED_COUNTRY_CODES)[number];
